import { render } from "./PlainAdminNavigation.vue?vue&type=template&id=b8d4ec50&scoped=true"
import script from "./PlainAdminNavigation.vue?vue&type=script&lang=js"
export * from "./PlainAdminNavigation.vue?vue&type=script&lang=js"

import "./PlainAdminNavigation.vue?vue&type=style&index=0&id=b8d4ec50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d4ec50"]])

export default __exports__